import { type QueryClient } from '@tanstack/react-query'
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import { Suspense } from 'react'
import { Toaster } from 'sonner'

import { TanStackRouterDevtools } from '@/components/tan-stack-router-devtools'

import { useIntercomMessenger } from '@/lib/hooks/use-intercom-messenger'

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient
}>()({
  component: Root,
})

function Root() {
  useIntercomMessenger()

  return (
    <>
      <Outlet />
      <Toaster position="bottom-center" />
      <Suspense>
        <TanStackRouterDevtools position="bottom-left" />
      </Suspense>
    </>
  )
}
